export const PAYROLL_MAQUILA_IDS = [
  19, 378, 558, 826, 838, 859, 907, 941, 959, 984, 1003, 1029, 1039, 1103, 1129, 1139,
  1245, 1272, 1311, 1338, 1351, 1372, 1415, 1463, 1716, 1860, 1891, 1962, 1966, 1969,
  1979, 2095, 2202, 2270, 2414, 2731, 1827
];

export const IDSE_NEW_SEND_IDS = [2465, 47, 3270, 3480, 3488];

export const USER_ROLE_DEFAULTS = {
  UNKNOWN: 'unknown',
};
